// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"6d48b6f0","182":"6d48b6f0","460":"6d48b6f0","518":"6d48b6f0","554":"6d48b6f0","644":"6d48b6f0","793":"6d48b6f0"}[chunkId] + ".chunk.css";
};